import { useEffect, useState } from "react";

import api from "@/lib/api";
import { Loader, Empty, Pagination } from "@/components/Page";
import { SKILL_META } from "@/lib/game";
import { formatStatTitle } from "@/lib/statTitles";

const directionTone = {
  up: "text-emerald-300",
  down: "text-orange-300",
};

const PAGE_SIZE = 20;

export const StatAdvancesPanel = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setData(null);
    api.get(`/training/stat-advances?page=${page}&limit=${PAGE_SIZE}`)
      .then((r) => setData(r.data || { items: [], page, total_pages: 1, total: 0 }))
      .catch(() => setData(false));
  }, [page]);

  if (data === null) return <Loader />;
  if (data === false) return <Empty label="Unable to load stat advance history right now." />;

  const items = data.items || [];
  if (!items.length) return <Empty label="No stat title changes recorded yet. Future promotions or demotions will appear here." />;

  return (
    <div data-testid="training-stat-advances" className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2 text-[11px] uppercase tracking-[0.18em] text-zinc-500">
        <div data-testid="training-stat-advances-count">{data.total} total recorded changes</div>
        <div>Newest changes first</div>
      </div>
      {items.map((entry) => {
        const label = SKILL_META[entry.stat_key]?.label || entry.stat_key;
        return (
          <div key={entry.id} data-testid={`stat-advance-${entry.id}`} className="border border-amber-900/30 bg-zinc-950 px-4 py-3 rounded-sm">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="font-cinzel text-amber-300 uppercase tracking-wide text-sm">{entry.gladiator_name}</div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-zinc-500">{label}</div>
                <div className={`mt-2 text-sm ${directionTone[entry.direction] || "text-zinc-200"}`}>
                  {formatStatTitle(entry.old_title)} → {formatStatTitle(entry.new_title)}
                </div>
                <div className="mt-1 text-xs text-zinc-500 tabular-nums">
                  {entry.old_value} → {entry.new_value}
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">{entry.direction === "down" ? "Demotion" : "Advance"}</div>
                <div className="mt-1 text-xs text-zinc-400" data-testid={`stat-advance-date-${entry.id}`}>
                  {new Date(entry.created_at).toLocaleString()}
                </div>
                {entry.source && <div className="mt-1 text-[10px] uppercase tracking-[0.18em] text-zinc-600">{String(entry.source).replaceAll("_", " ")}</div>}
              </div>
            </div>
          </div>
        );
      })}
      <Pagination page={data.page || page} totalPages={data.total_pages || 1} onChange={setPage} testid="training-stat-advances-pagination" className="mt-5" />
    </div>
  );
};